import {Type} from '@github-ui/react-query-persister/typebox'
import {Compile} from '@github-ui/react-query-persister/typebox/compile'

/** The card menu actions this client can ask `card-actions` about, named as the server takes them. */
export const ASSIGN_AGENT_CARD_ACTION = 'assign_agent'

const AssignAgentActionSchema = Type.Object({available: Type.Boolean()})

/**
 * One card's answers, each in its own shape. An action the request did not name is absent. Others
 * are allowed, so a client deployed before the server answers another action keeps working.
 */
const CardActionsSchema = Type.Object({
  assignAgent: Type.Optional(AssignAgentActionSchema),
})
export type BoardCardActions = Type.Static<typeof CardActionsSchema>

const CardActionsItemSchema = Type.Object({
  globalId: Type.String(),
  type: Type.Union([Type.Literal('issue'), Type.Literal('pull_request')]),
  actions: CardActionsSchema,
})

/** The menu actions of cards a board already drew, from `card-actions?ids=&actions=`. */
const CardActionsPayloadSchema = Type.Object({
  items: Type.Array(CardActionsItemSchema),
})
export type BoardCardActionsPayload = Type.Static<typeof CardActionsPayloadSchema>

const boardCardActionsPayloadValidator = Compile(CardActionsPayloadSchema)

export function isBoardCardActionsPayload(value: unknown): value is BoardCardActionsPayload {
  return boardCardActionsPayloadValidator.Check(value)
}
